import crypto from 'crypto';

const getChecksum = (data, algorithm = 'sha256', encoding = 'hex') => crypto.createHash(algorithm).update(data).digest(encoding);

export default getChecksum;